module.exports = __webpack_public_path__ + "static/media/logo_sparta.262c8621.png";